// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"246c7be0","124":"356126bc"}[chunkId] + ".chunk.js";
};